<p class="kdgh-label">
  <ng-content></ng-content>
</p>
